import { SVGELEMENT } from '../../../../enums/SVGELEMENT.js';
import EL from '../../../EL/EL.js';
import { makeStruct } from '../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../enums/ModelData.js';
import { SVGANIMATIONELEMENT } from '../../../../enums/SVGANIMATIONELEMENT.js';
import SVGSET, { svgSet } from '../../../DOM/svg/SVGOBJECT/SVGANIMATION/SVGSET.js';
import SVGANIMATETRANSFORM, { svgAnimateTransform } from '../../../DOM/svg/SVGOBJECT/SVGANIMATION/SVGANIMATETRANSFORM.js';
import SVGANIMATE, { svgAnimate } from '../../../DOM/svg/SVGOBJECT/SVGANIMATION/SVGANIMATE.js';
import SVGANIMATEMOTION, { svgAnimateMotion } from '../../../DOM/svg/SVGOBJECT/SVGANIMATION/SVGANIMATEMOTION.js';
// Model Structure
export const svgShapeAttr = makeAttrStruct([
    ['width'],
    ['height'],
    ['x'],
    ['y'],
    ['transform'],
    ['clip-path']
]);
export const svgShapeData = makeDataStruct([
    ['children', []]
]);
export const svgShapeModel = makeStruct([
    ['attributes', svgShapeAttr],
    ['data', svgShapeData]
]);
// Simplified Model
export function svgshape(attributes, data) {
    return {
        attributes: attributes || svgShapeAttr(100, 100, 0, 0, '', ''),
        data: data || svgShapeData([])
    };
}
/** Creates a Shape/Path for an SVG */
export default class SVGSHAPE extends EL {
    // declare public el: SVGElement; // Declare the SVG Element type
    constructor(node, element, model) {
        super(node, element, model);
        this.buildSVGAnimation(model.data.children ?? []);
    }
    // /** Creates the DOM HTMLElement during instantiation
    //  * Override this method to create a custom element
    //  */
    createElement() {
        const el = document.createElementNS('http://www.w3.org/2000/svg', this.element);
        return el;
    }
    /** Adds an Animation element to this SVG Shape */
    // addAnimation(type: SVGANIMATIONELEMENT, model: SVGAnimationElementModel): SVGANIMATION<SVGAnimationElementModel> {
    // 	return this.addChild<SVGANIMATION<SVGAnimationElementModel>>(new SVGANIMATION(this, model));
    // }
    buildSVGAnimation(vectors) {
        vectors.forEach((vector) => {
            switch (vector.element) {
                case SVGANIMATIONELEMENT.SET:
                    this.addChild(new SVGSET(this, svgSet(vector.attributeName, vector.to, vector.begin)));
                    break;
                case SVGANIMATIONELEMENT.ANIMATETRANSFORM:
                    this.addChild(new SVGANIMATETRANSFORM(this, svgAnimateTransform(vector.attributeName, vector.begin, vector.dur, vector.type, vector.repeatCount, vector.from, vector.to, vector.keyTimes)));
                    break;
                case SVGANIMATIONELEMENT.ANIMATE:
                    this.addChild(new SVGANIMATE(this, svgAnimate(vector.attributeName, vector.begin, vector.dur, vector.repeatCount, vector.from, vector.to)));
                    break;
                case SVGANIMATIONELEMENT.ANIMATEMOTION:
                    this.addChild(new SVGANIMATEMOTION(this, svgAnimateMotion(vector.attributeName, vector.begin, vector.dur)));
                    break;
                case SVGELEMENT.TSPAN:
                    break; // Handled in SVGTEXT
                default:
                    console.warn('SVG.setPaths: vector.type is undefined', vector);
            }
        });
    }
}
